import { render, staticRenderFns } from "./editProviderNewGame.vue?vue&type=template&id=aa85c510&lang=pug"
import script from "./editProviderNewGame.vue?vue&type=script&lang=js"
export * from "./editProviderNewGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports